/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Network layer service
 */

namespace Application.Services {
    'use strict';

    import NetworkNodeType = Models.NetworkNodeType;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;

    /**
     * NetworkNodeTypeService
     */
    export class NetworkNodeTypeService {
        public static $name: string = "networkNodeTypeService";
        public static $inject: string[] = ['$http', '$q', '$rootScope'];

        private http: ng.IHttpService;
        private $q: ng.IQService;
        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private $rootScope: IFlexRootScope;
        private networkNodeTypesUrl: string = this.backendBaseUrl + this.servicePath + 'networkNodeTypes';
        private searchByVisiblePath: string = '/search/findAllByVisible?visible=true';

        private networkNodeTypes: NetworkNodeType[];

        constructor($http: ng.IHttpService, $q: ng.IQService, $rootScope: IFlexRootScope) {
            this.http = $http;
            this.$q = $q;
            this.$rootScope = $rootScope;

            this.$rootScope.$on('vars.isUserLoggedIn', (event: ng.IAngularEvent, args: boolean) => {
                if (args) {
                    this.getAllNetworkNodeTypes();
                }
            });
        }

        public getAllNetworkNodeTypes(): ng.IPromise<NetworkNodeType[]> {
            if (this.networkNodeTypes && this.networkNodeTypes.length > 0) {
                let deferred: ng.IDeferred<NetworkNodeType[]> = this.$q.defer();
                deferred.resolve(this.networkNodeTypes);
                return deferred.promise;
            } else {
                return this.http
                    .get(this.networkNodeTypesUrl + this.searchByVisiblePath)
                    .then((response: ng.IHttpPromiseCallbackArg<IHalList<NetworkNodeType>>) => {
                        let halList: IHalList<NetworkNodeType> = response.data;
                        this.networkNodeTypes = HalConverter.convertList(halList, NetworkNodeType.Empty);
                        return this.networkNodeTypes;
                    });
            }
        }

        public findByHref(hrefString: string): ng.IPromise<NetworkNodeType> {
            if (this.networkNodeTypes && this.networkNodeTypes.length > 0) {
                let deferred: ng.IDeferred<NetworkNodeType> = this.$q.defer();
                let networkNodeType: NetworkNodeType;
                [networkNodeType] = this.networkNodeTypes.filter(
                    (nnt: NetworkNodeType) => {
                        return nnt.href === hrefString;
                    });
                networkNodeType ? deferred.resolve(networkNodeType) : deferred.reject(undefined);
                return deferred.promise;
            } else {
                return this.http.get(hrefString).then(
                    (data: ng.IHttpPromiseCallbackArg<IHalElement<NetworkNodeType>>) => {
                        let halElement: IHalElement<NetworkNodeType> = data.data;
                        let converted: NetworkNodeType = HalConverter.convertElement(halElement, NetworkNodeType.Empty);
                        return converted;
                    }
                );
            }
        }

        public findById(id: number): ng.IPromise<NetworkNodeType> {
            if (this.networkNodeTypes && this.networkNodeTypes.length > 0) {
                let deferred: ng.IDeferred<NetworkNodeType> = this.$q.defer();
                let networkNodeType: NetworkNodeType;
                [networkNodeType] = this.networkNodeTypes.filter(
                    (nnt: NetworkNodeType) => {
                        return Common.Utils.idFromHref(nnt.href) === id;
                    });
                networkNodeType ? deferred.resolve(networkNodeType) : deferred.reject(undefined);
                return deferred.promise;
            } else {
                return this.http.get(this.networkNodeTypesUrl + "/" + id).then(
                    (data: ng.IHttpPromiseCallbackArg<IHalElement<NetworkNodeType>>) => {
                        let halElement: IHalElement<NetworkNodeType> = data.data;
                        let converted: NetworkNodeType = HalConverter.convertElement(halElement, NetworkNodeType.Empty);
                        return converted;
                    }
                );
            }
        }

        public update(networkNodeType: Application.Models.INetworkNodeType): void {
            this.http.put(networkNodeType.href, networkNodeType).then(
                (data: ng.IHttpPromiseCallbackArg<IHalElement<NetworkNodeType>>) => {
                    let halElement: IHalElement<NetworkNodeType> = data.data;
                    let converted: NetworkNodeType = HalConverter.convertElement(halElement, NetworkNodeType.Empty);
                    this.getAllNetworkNodeTypes();
                    return converted;
                }
            );
        }

        public findByName(name: string): ng.IPromise<Models.INetworkNodeType> {
            return this.getAllNetworkNodeTypes().then((types: Models.INetworkNodeType[]) => {
                for (let type of types) {
                    if (type.name === name) {
                        return type;
                    }
                }
            });
        }
    }
}
